<script>
  import relatorioServico from '../relatorio.servico';
  import projetoServico from '~modulos/projeto/servico';

  import 'select2';
  import 'select2/dist/js/i18n/pt-BR';
  import 'vue-strap/dist/vue-strap-lang'; 

  import { radio, datepicker } from 'vue-strap';
  import CabecalhoRelatorio from '~componentes/CabecalhoRelatorio.vue';
  import TelaCheia from '~componentes/TelaCheia.vue';

  export default {
    components: { datepicker, radio, CabecalhoRelatorio, TelaCheia },
    data() {
      return {
        filtros: {
          idProjeto: '',
          idConta: '',
          dataInicio: moment(new Date()).format('DD/MM/YYYY'),
          dataFim: moment(new Date()).format('DD/MM/YYYY'),
          rendimentoLiquido: 'false',
        },
        projetos: [],
        contas: [],
        relatorio: [],
        projeto: null,
        mostrarRendimentoLiquido: false,
        configuracao: this.$storage.configuracao(),
      }
    },
    methods: {
      listaDeProjetos() {
        return projetoServico
          .listaDeProjetosPermissao("RelLancamentoAplicacao")
          .then(projetos => {
            this.projetos = projetos;
          });
      },
      gerar() {
        this.relatorio = {};
        this.setarProjeto();

        this.$validator
          .validateAll()
          .then(valido => {
            if (!valido) throw new Error("validacao");
            
            $('#gerar').button('loading');

            return relatorioServico.aplicacoesFinanceiras(this.filtros)
          })
          .then(resultado => {
            this.relatorio = resultado.groupBy('nomeTipoAplicacao');
            this.mostrarRendimentoLiquido = this.filtros.rendimentoLiquido === 'true';
            
            $('#gerar').button('reset');
            
            if (resultado.length === 0) {
              this.$swal('', 'Nenhum resultado encontrado.', 'info');
            } else {
              this.$nextTick(() => {
                $('html, body').animate({
                  scrollTop: $('#relatorio').offset().top
                }, 800);
              });
            }
          })
          .catch(erro => {
            $('#gerar').button('reset');

            if (erro.status === 422) {
              this.$mensagemErro(erro, erro.body.message);
            } else {
              this.$mensagemErro(erro, 'Erro ao gerar relatório.');
            }
          });
      },
      gerarExcel() {
        this.relatorio = {};
        this.setarProjeto();

        this.$validator
          .validateAll()
          .then(valido => {
            if (!valido) throw new Error("validacao");

            $('#gerar-excel').button('loading');

            return relatorioServico.aplicacoesFinanceirasExcel(this.filtros)
          })
          .then(arquivo => {
            $('#gerar-excel').button('reset');

            if (arquivo === '') {
              this.$swal('', 'Nenhum resultado encontrado.', 'info');
            } else {
              arquivo.download();
            }
          })
          .catch(erro => {
            $('#gerar-excel').button('reset');

            this.$mensagemErro(erro, 'Erro ao gerar relatório.');
          });
      },
      listaContas(idProjeto) {
        return projetoServico
          .contasProjeto(idProjeto)
          .then(contas => {
            this.contas = contas;
          });
      },
      saldoParcial(grupo, indice) {
        return this.relatorio[grupo][0].saldoAnterior + this.relatorio[grupo].reduce((total, item, i) => {
          if (i > indice) return total;

          if (item.creditoDebito === 1) {
            return total + item.valorOperacaoAplicacao;
          } else {
            return total - item.valorOperacaoAplicacao;
          }
        }, 0);
      },
      setarProjeto() {
        const idProjeto = this.filtros.idProjeto;

        this.projeto = idProjeto ? this.projetos.find(projeto => projeto.idProjeto == idProjeto) : null; 
      }
    },
    computed: {
      rendimentoLiquido() {
        return Object.keys(this.relatorio).reduce((totalAplicacao, indiceAplicacao) => {
          return totalAplicacao + this.relatorio[indiceAplicacao].reduce((total, item) => {
            if (item.creditoDebito === 1) {
              return total + item.valorOperacaoAplicacao;
            } else {
              return total - item.valorOperacaoAplicacao;
            }
          }, 0);
        }, 0);
      }
    },
    mounted() {
      this.$root.tituloDaPagina = `Relatório de Aplicações Financeiras`;
      this.$root.botaoAcaoTexto = 'Imprimir relatório';
      this.$root.botaoAcaoIcon = 'fa-print';
      this.$root.botaoAcaoLink = '';

      this.$root.botaoRetrocederMostrar = false;
      this.$root.botaoRetrocederRota = '';

      this.$events.on('botaoAcao', function() {
        window.print();
      });

      this.listaDeProjetos();

      const _this = this;

      //$('.datepicker input').attr('readonly', '');

      $('#projeto').select2({
        theme: "bootstrap",
        placeholder: "Selecione...",
        language: "pt-BR"
      })
      .change(function(e) {
        _this.$set(_this.filtros, 'idProjeto', this.value);
        _this.listaContas(this.value);
      });
    },
    beforeDestroy() {
      this.$events.off('botaoAcao');
    }
  }
</script>

<template>
  <div :class="['wrapper wrapper-content animated', $root.animacaoPadrao]">
    <form class="hidden-print" @submit.prevent="gerar">

      <div class="ibox float-e-margins">
        <div class="ibox-content">
          <div class="row">
            <div class="col-sm-6">
              <div class="form-group required" :class="{'has-error': errors.has('dataInicio')}">
                <label class="control-label">Período</label>

                <datepicker id="dataInicio"
                            v-mascara="'data-mask'"
                            v-model="filtros.dataInicio"
                            format="dd/MM/yyyy"
                            placeholder="  /  /     "
                            lang="pt-BR">
                </datepicker>

                <p class="text-danger" v-show="errors.has('dataInicio')">{{ errors.first('dataInicio') }}</p>
              </div>
            </div>

            <div class="col-sm-6">
              <div class="form-group" :class="{'has-error': errors.has('dataFim')}">
                <label class="control-label">&nbsp; &nbsp;</label>

                <datepicker id="dataFim"
                            v-mascara="'data-mask'"
                            v-model="filtros.dataFim"
                            format="dd/MM/yyyy"
                            placeholder="  /  /     "
                            lang="pt-BR">
                </datepicker>
              </div>
            </div>
          </div>

          <div class="row">
            <div class="col-xs-6">
              <div class="form-group">
                <radio v-model="filtros.rendimentoLiquido"
                       selected-value="false"
                       type="success">
                  Completo
                </radio>
              </div>
            </div>

            <div class="col-xs-6">
              <div class="form-group">
                <radio v-model="filtros.rendimentoLiquido"
                       selected-value="true"
                       type="success">
                  Rendimento líquido
                </radio>
              </div>
            </div>
          </div>

          <div class="row">
            <div class="col-xs-12">
              <div class="form-group required" :class="{'has-error': errors.has('projeto')}">
                <label class="control-label" for="projeto">Projeto</label>

                <select id="projeto"
                        class="form-control"
                        v-model="filtros.idProjeto"
                        data-vv-name="projeto"
                        v-validate="'required'">
                  <option value="">Selecione...</option>
                  <option :value="projeto.idProjeto" v-for="(projeto, index) in projetos">{{ projeto.nomeProjeto }}</option>
                </select>

                <p class="text-danger" v-show="errors.has('projeto')">{{ errors.first('projeto') }}</p>
              </div>
            </div>
          </div>

          <div class="row" v-if="configuracao.filtrarLancamentoContaCorrenteWeb">
            <div class="col-xs-12">
              <div class="form-group">
                <label class="control-label" for="id-conta">Conta</label>

                <select id="id-conta"
                        class="form-control"
                        v-model="filtros.idConta">
                  <option value="">{{ contas.length > 0 ? 'Selecione...' : 'Selecione a conta' }}</option>
                  <option :value="conta.idConta" v-for="conta in contas">{{ conta.nomeConta }}</option>
                </select>
              </div>
            </div>
          </div>

        </div>
      </div>

      <div class="row">
        <div class="col-xs-12">
          <div class="form-group">
            <button id="gerar"
                    type="button"
                    class="btn btn-primary"
                    @click="gerar"
                    data-loading-text="<i class='fa fa-spinner fa-pulse'></i> Gerando relatório...">
              <i class="fa fa-line-chart"></i>
              Gerar relatório
            </button>

            <button id="gerar-excel"
                    type="button"
                    class="btn btn-primary"
                    @click="gerarExcel"
                    data-loading-text="<i class='fa fa-spinner fa-pulse'></i> Gerando relatório...">
              <i class="fa fa-table"></i>
              Gerar relatório em excel
            </button>

            <tela-cheia texto="Visualizar em tela cheia"
                        icone="arrows-alt"
                        v-if="Object.keys(relatorio).length !== 0">
            </tela-cheia>
          </div>
        </div>
      </div>
    </form>

    <cabecalho-relatorio titulo="Relatório de Aplicações Financeiras" borda=""></cabecalho-relatorio>

    <div class="row" v-if="Object.keys(relatorio).length !== 0" id="relatorio">
      <div class="col-lg-12">
        <div class="ibox float-e-margins">
          <div class="ibox-content">

            <div class="table-responsive">
              <table class="table table-condensed no-margins">
                <thead>
                  <tr>
                    <th>Projeto</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td class="no-border-right">{{ projeto.nomeProjeto}}</td>
                  </tr>
                </tbody>
              </table>
            
              <template v-for="(aplicacao, indiceAplicacao) in relatorio">
                <table class="table relatorio table-bordered no-margins">
                  <thead>
                    <tr>
                      <th class="no-border-right">Aplicação</th>
                      <th class="text-right no-border-left">Saldo anterior (R$)</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td class="no-border-right">{{ aplicacao[0].nomeTipoAplicacao }}</td>
                      <td :class="['text-right no-border-left', aplicacao[0].saldoAnterior > 0 ? 'text-primary' : 'text-danger']">{{ aplicacao[0].saldoAnterior | formatarNumero }}</td>
                    </tr>
                  </tbody>
                </table>
              
                <table class="table relatorio table-bordered no-margins">
                  <thead>
                    <tr>
                      <th>Data</th>
                      <th>Histórico</th>
                      <th class="text-center">C/D</th>
                      <th class="text-right">Valor (R$)</th>
                      <th class="text-right">Saldo parcial (R$)</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="(item, indice) in aplicacao">
                      <td>{{ item.data | formatarData }}</td>
                      <td>{{ item.historicoOperacaoAplicacao }}</td>
                      <td class="text-center">{{ item.creditoDebito === 1 ? 'C' : 'D' }}</td>
                      <td :class="['text-right', item.creditoDebito === 1 ? 'text-primary' : 'text-danger']">{{ item.creditoDebito === 1 ? '' : '-' }}{{ item.valorOperacaoAplicacao | formatarNumero }}</td>
                      <td :class="['text-right', saldoParcial(indiceAplicacao, indice) >= 0 ? 'text-primary' : 'text-danger']">{{ saldoParcial(indiceAplicacao, indice) | formatarNumero }}</td>
                    </tr>
                  </tbody>
                </table>
              </template>
              
              <table class="table relatorio table-bordered no-margins">
                <tbody>
                  <tr v-if="mostrarRendimentoLiquido">
                    <td class="text-right" colspan="5"><b>Rendimento líquido: <span class="text-primary">R$ {{ rendimentoLiquido | formatarNumero }}</span></b></td>
                  </tr>
                </tbody>
              </table>
            </div>

          </div>
        </div>
      </div>
    </div>
  </div>
</template>



// WEBPACK FOOTER //
// FrontEnd/modulos/relatorio/componentes/AplicacoesFinanceiras.vue